export function setUpRadioDetailsSectionData(content) {
  return (content || []).map((con) => con.fieldText);
}

export function setUpCheckBoxFacilityAddonSectionData(content) {
  return (content || []).map((con) => con.facilityname);
}

export function parseTextWithLinks(text, buttonColor = "#0275FF") {
  if (!text) return "";
  const urlPattern = /(https?:\/\/[^\s]+)|(www\.[^\s]+)/g;
  const match = text.match(urlPattern);
  if (match) {
    const url = match[0];
    const displayTextPattern = /\[([^\]]+)]/;
    const displayTextMatch = text.match(displayTextPattern);
    const displayText = displayTextMatch ? displayTextMatch[1] : url;
    return text
      .replace(urlPattern, "")
      .replace(
        displayTextPattern,
        `<a style="color: ${buttonColor}; text-decoration: none" href="${url}" target="_blank" rel="noopener noreferrer">${displayText}</a>`
      );
  }
  return text;
}

export function getOptionImageUrl(option) {
  if (!option || typeof option !== "object") return null;
  const url =
    option.imageUrl ||
    option.ImageUrl ||
    option.image ||
    option.Image ||
    option.imageURL ||
    "";
  const trimmed = typeof url === "string" ? url.trim() : "";
  if (!trimmed || trimmed === "null" || trimmed === "undefined") return null;
  return trimmed;
}

export function getImageUrlForSelection(content, selectedValue) {
  if (!Array.isArray(content) || selectedValue == null || selectedValue === "") {
    return null;
  }
  const selectedValues = Array.isArray(selectedValue)
    ? selectedValue
    : [selectedValue];
  const data = content.find((field) =>
    selectedValues.includes(field.fieldText)
  );
  return data ? getOptionImageUrl(data) : null;
}

export function isDocUploadRequiredForSelection(content, selectedValue) {
  if (!Array.isArray(content) || selectedValue == null) return false;
  const selectedValues = Array.isArray(selectedValue)
    ? selectedValue
    : [selectedValue];
  const data = content.find((field) =>
    selectedValues.includes(field.fieldText)
  );
  return Boolean(data?.isDocRequired);
}

export function buildDetailQuestions(
  detailsSettings,
  detailsSelectedRadio,
  detailImages,
  venueType
) {
  const detailQuestions = [];
  const activeSettings = (detailsSettings || []).filter(
    (s) => s.isActive && s.venuetype === venueType
  );

  for (let index = 0; index < activeSettings.length; index++) {
    const setting = activeSettings[index];
    const globalIndex = detailsSettings.indexOf(setting);
    const selectedRadio = detailsSelectedRadio[globalIndex];

    if (selectedRadio == null || selectedRadio === undefined) {
      continue;
    }

    const settingContent = setting.content || [];
    const selectedValues = Array.isArray(selectedRadio)
      ? selectedRadio
      : [selectedRadio];
    const data = settingContent.find((field) =>
      selectedValues.includes(field.fieldText)
    );

    if (!data) {
      return { detailQuestions: null, error: "missing_answer" };
    }

    const isDocRequired = Boolean(data.isDocRequired);
    const fileEntry = detailImages[globalIndex];

    detailQuestions.push({
      question: setting.title,
      answer: selectedRadio,
      key: globalIndex,
      isDocRequired,
      file: isDocRequired && fileEntry ? fileEntry : "",
    });
  }

  return { detailQuestions, error: null };
}

export function validateRequiredUploads(detailQuestions) {
  const missing = [];
  for (const item of detailQuestions || []) {
    if (item.isDocRequired === true && (!item.file || !item.file.file)) {
      missing.push(item.question);
    }
  }
  return missing;
}

export function buildSecondPageDetails(
  detailQuestions,
  detailImages,
  venueBlockId
) {
  const secondPageDetails = [];
  const blockPrefix = Array.isArray(venueBlockId)
    ? venueBlockId[0]
    : venueBlockId;

  for (let index = 0; index < (detailQuestions || []).length; index++) {
    const newValue = detailQuestions[index];
    if (!newValue || newValue.answer == null) continue;

    if (typeof newValue.answer !== "object") {
      const hasAnswer =
        (typeof newValue.answer === "string" && newValue.answer.length >= 1) ||
        newValue.answer;
      if (!hasAnswer) continue;

      if (newValue.isDocRequired && newValue.file?.file) {
        secondPageDetails.push({
          question: newValue.question,
          answer: [newValue.answer],
          key: newValue.key,
          isDocRequired: newValue.isDocRequired,
          file: `${blockPrefix}_${newValue.file.file.name}`,
        });
      } else {
        secondPageDetails.push({
          question: newValue.question,
          answer: [newValue.answer],
          key: newValue.key,
          isDocRequired: newValue.isDocRequired,
          file: "",
        });
      }
    } else if (newValue.answer?.length >= 1) {
      const imageValue = detailImages[newValue.key];
      if (imageValue?.file) {
        secondPageDetails.push({
          file: `${blockPrefix}_${imageValue.file.name}`,
          question: newValue.question,
          answer: newValue.answer,
          key: newValue.key,
        });
      } else {
        secondPageDetails.push({
          question: newValue.question,
          answer: newValue.answer,
          key: newValue.key,
        });
      }
    }
  }

  const ids = secondPageDetails.map(({ key }) => key);
  return secondPageDetails.filter(
    ({ key }, idx) => !ids.includes(key, idx + 1)
  );
}
